import InventIdea from './components/InventIdea.vue'
import Note from './components/Note.vue'
import ImageExtra from './components/ImageExtra.vue'
import DetailList from './components/DetailList.vue'
import Popular from './components/Popular.vue'
import InventPanorama from './components/InventPanorama.vue'
import StructuredContent from './components/StructuredContent.vue'
import Terminology from './components/Terminology.vue'
import FeatureBreakdown from './components/FeatureBreakdown.vue'
import TechnicalFlow from './components/TechnicalFlow.vue'
import NoveltyAnalysis from './components/NoveltyAnalysis.vue'
import CreativityAnalysis from './components/CreativityAnalysis.vue'
import CompletenessAnalysis from './components/CompletenessAnalysis.vue'
import StrategicAlignment from './components/StrategicAlignment.vue'
import ProtectionStrategy from './components/ProtectionStrategy.vue'
import TagLabel from './components/TagLabel.vue'
import FileViewer from './components/FileViewer.vue'
import PendingModule from './components/PendingModule.vue'

const createApplication = (config) => ({
  icon: 'application/analysis',
  moduleStatus: '新增',
  exportable: false,
  required: false,
  component: PendingModule,
  ...config,
})

const strategicAlignmentApplication = {
  type: '判断类',
  id: 'StrategicAlignment',
  name: '战略匹配',
  description: '从企业战略方向、产品布局和应用场景等角度评估技术方案与业务战略的匹配程度。',
  componentTypeCode: 'comp_sta',
  component: StrategicAlignment,
}

export const applicationList = [
  createApplication({
    type: '文件类',
    id: 'Note',
    name: '查阅批注',
    icon: 'application/note.png',
    moduleStatus: '修改',
    description: '用于查看上传的交底书及相关技术文件内容，并支持文本高亮、批注、荧光标记和修订记录展示。',
    componentTypeCode: 'comp_ann',
    required: true,
    exportable: true,
    component: Note,
  }),
  createApplication({
    type: '理解类',
    id: 'FeatureBreakdown',
    name: '特征拆解',
    icon: 'application/structured-content.png',
    componentTypeCode: 'comp_fea',
    component: FeatureBreakdown,
    description: '将技术方案拆解为结构化的技术特征或技术步骤，形成清晰的技术特征列表，为后续分析提供基础对比单元。',
  }),
]

const hiddenApplications = [
  createApplication({
    type: '理解类',
    id: 'TechnicalFlow',
    name: '方案拆解',
    icon: 'application/invent-panorama.png',
    componentTypeCode: 'comp_tfl',
    component: TechnicalFlow,
    description: '根据交底书中的技术方案生成系统流程结构或模块关系视图，帮助评审人员理解技术实现路径及模块关系。',
  }),
]

applicationList.push(
  createApplication({
    type: '理解类',
    id: 'ImageExtra',
    name: '附图提取',
    icon: 'application/image-extra.png',
    moduleStatus: '现有',
    description: '自动提取交底书中的流程图、结构图或界面图，并与相关技术内容进行关联展示。',
    componentTypeCode: 'comp_draw',
    required: true,
    exportable: true,
    component: ImageExtra,
  }),
  createApplication({
    type: '理解类',
    id: 'Terminology',
    name: '术语表',
    icon: 'application/terminology.png',
    moduleStatus: '现有',
    description: '提取交底书中的关键术语、缩写和专业概念，并统一展示术语定义。',
    componentTypeCode: 'comp_glo',
    required: true,
    component: Terminology,
  }),
  createApplication({
    type: '理解类',
    id: 'Popular',
    name: '通俗解释',
    icon: 'application/popular.png',
    moduleStatus: '现有',
    description: '使用简明语言概括技术目的、实现方式和应用场景，帮助非技术人员或 IPR 快速理解发明内容。',
    componentTypeCode: 'comp_poe',
    required: true,
    component: Popular,
  }),
  createApplication({
    type: '理解类',
    id: 'InventIdea',
    name: '发明构思',
    icon: 'application/invent-idea.png',
    moduleStatus: '现有',
    description: '对发明方案的整体思路进行总结，提炼技术关键点或创新点，帮助快速把握技术方案核心逻辑。',
    componentTypeCode: 'comp_inv',
    required: true,
    exportable: true,
    component: InventIdea,
  }),
  createApplication({
    type: '判断类',
    id: 'NoveltyAnalysis',
    name: '新颖性分析',
    description: '基于技术特征与现有技术文献进行语义化对比分析，判断技术方案是否已经被公开。',
    componentTypeCode: 'comp_nov',
    component: NoveltyAnalysis,
  }),
  createApplication({
    type: '判断类',
    id: 'CreativityAnalysis',
    componentTypeCode: 'comp_cre',
    component: CreativityAnalysis,
    name: '创造性分析',
    description: '识别最接近现有技术及差异技术特征，分析其是否具备显著技术进步或非显而易见性。',
  }),
  createApplication({
    type: '判断类',
    id: 'CompletenessAnalysis',
    componentTypeCode: 'comp_cmp',
    component: CompletenessAnalysis,
    name: '充分公开分析',
    description: '分析交底书是否完整、清楚地描述技术问题、技术方案及技术效果，并提示需要补充或澄清的内容。',
  }),
  createApplication(strategicAlignmentApplication),
  createApplication({
    type: '判断类',
    id: 'ProtectionStrategy',
    componentTypeCode: 'comp_prs',
    component: ProtectionStrategy,
    name: '保护策略',
    description: '根据技术方案和关键技术特征生成建议保护策略，为后续撰写权利要求提供参考。',
  }),
  createApplication({
    type: '确认类',
    id: 'TagLabel',
    name: '标签标注',
    icon: 'application/tag-label',
    componentTypeCode: 'comp_tag',
    component: TagLabel,
    description: '从多个维度对交底书进行标签标注，形成结构化标签信息，便于后续分类管理和快速筛选。',
  }),
  createApplication({
    type: '确认类',
    id: 'DetailList',
    name: '交流清单',
    icon: 'application/detail-list.png',
    moduleStatus: '现有',
    description: '汇总评审过程中识别出的疑问点、风险点或需要补充的信息，形成结构化交流问题列表。',
    componentTypeCode: 'comp_comm',
    exportable: true,
    component: DetailList,
  }),
)

const legacyApplications = [
  createApplication({
    ...strategicAlignmentApplication,
    id: 'BusinessValueAnalysis',
  }),
  createApplication({
    type: '文件类',
    id: 'FileViewer',
    name: '文件查看',
    icon: 'application/note.png',
    moduleStatus: '运行时',
    description: '运行时文件查看组件，用于动态文件类实例渲染。',
    component: FileViewer,
  }),
  createApplication({
    type: '理解类',
    id: 'InventPanorama',
    name: '发明全景图',
    icon: 'application/invent-panorama.png',
    moduleStatus: '停用',
    description: '旧模板兼容组件，当前不在新增模块列表中展示。',
    componentTypeCode: 'comp_inp',
    component: InventPanorama,
  }),
  createApplication({
    type: '理解类',
    id: 'StructuredContent',
    name: '结构化内容',
    icon: 'application/structured-content.png',
    moduleStatus: '停用',
    description: '旧模板兼容组件，当前不在新增模块列表中展示。',
    componentTypeCode: 'comp_stc',
    component: StructuredContent,
  }),
]

const applicationRegistry = [...applicationList, ...hiddenApplications, ...legacyApplications]

export const applicationMetaMap = applicationRegistry.reduce((result, item) => {
  result[item.id] = item
  return result
}, {})

export const applicationDataMap = applicationRegistry.reduce((result, item) => {
  if (item.componentTypeCode) {
    result[item.id] = item.componentTypeCode
  }
  return result
}, {})

export const exportableApplications = applicationList.filter(item => item.exportable && item.componentTypeCode)

export const step2RequiredComponentCodes = applicationList
  .filter(item => item.required && item.componentTypeCode)
  .map(item => item.componentTypeCode)

export const getApplicationConfig = (id) => applicationMetaMap[id] || null

export const getApplicationDataCode = (id) => applicationDataMap[id] || ''

export default applicationRegistry.reduce((result, item) => {
  result[item.id] = item.component
  return result
}, {})
